module.exports = __webpack_public_path__ + "img/noResource.b7857c2b.png";